import React, { useState } from 'react'
import "./Blog.css"
import BlogHero from '../../components/pages/Blog/BlogHero/BlogHero'
import Navbar from '../../components/shared/Navbar/Navbar'
import Footer from '../../components/shared/Footer/Footer'
import { blogPosts } from '../../data/blogPosts'
import { Link } from 'react-router-dom'
import { FaArrowRight } from "react-icons/fa";

const ITEMS_PER_PAGE = 3;

const Blog = () => {
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const visiblePosts = blogPosts.slice(0, visibleCount);
  const canLoadMore = visibleCount < blogPosts.length;

  const handleLoadMore = () => {
    if (isLoadingMore || !canLoadMore) return;
    setIsLoadingMore(true);
    window.setTimeout(() => {
      setVisibleCount((prev) => prev + ITEMS_PER_PAGE);
      setIsLoadingMore(false);
    }, 900);
  };

  return (
            <div className='blog-page'>
            <Navbar theme="light" />
            <BlogHero/>
            <div className="blog-page-content-guide">
              <section className="blog blog-page-posts">
                <div className="blog-container">
                  <span className="blog-tag tag">BLOG POSTS</span>
                  <h2 className="blog-title">Latest news and articles</h2>
                  <div className="blog-grid">
                    {visiblePosts.map((post, index) => (
                      <Link to={`/blog/${post.id}`} className="blog-card" key={post.id}>
                        <div className="blog-img">
                          <img src={post.image} alt={post.title} />
                        </div>

                        <div className="blog-content">
                          <span className="blog-date">{post.date}</span>
                          <h3>{post.title}</h3>
                          <p>{post.desc}</p>
                          <span className="blog-link">
                            Read article <FaArrowRight />
                          </span>
                        </div>

                        {index !== visiblePosts.length - 1 && <div className="divider" />}
                      </Link>
                    ))}
                  </div>

                  {(canLoadMore || isLoadingMore) && (
                    <div className="blog-page-loadWrap">
                      <button
                        type="button"
                        className="blog-page-loadBtn"
                        onClick={handleLoadMore}
                        disabled={isLoadingMore}
                      >
                        {isLoadingMore ? (
                          <>
                            <span className="blog-page-spinner" aria-hidden />
                            <span>Loading...</span>
                          </>
                        ) : (
                          <span>Load more</span>
                        )}
                      </button>
                    </div>
                  )}
                </div>
              </section>
            </div>
            <Footer />
        </div>
  )
}

export default Blog